import axios from 'axios'
import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Modal,Toast, Container, OverlayTrigger, Tooltip, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { obtenerGrillaHistorial } from '../../store/actions/contacto-tercero-action'


const Historial = ({handleClose}) => {
  const [show, setShow] = useState(false)
  const [listaGrilla, setListaGrilla] = useState(null)

  const [instancias, setInstancias] = useState("")
  const data_modal_contacto = useSelector((state) => state.modalContactoTerceroReducer)
  const { cfg_form24,datosUltimoContacto, grillaHitos} = data_modal_contacto
  const data_recepciona = useSelector((state) => state.casoGeneralReducer)
  const { llaves} = data_recepciona
  const data_traza_modal = useSelector((state) => state.trazabilidadReducer)
  const {datosGestion} = data_traza_modal
  const dispatch = useDispatch()
useEffect(()=>{
  setListaGrilla(grillaHitos && grillaHitos.grillaHitos)
},[grillaHitos])
useEffect(()=>{

  setInstancias(
    datosUltimoContacto && datosUltimoContacto.datosUltimoContacto[0] !== undefined &&
      datosUltimoContacto.datosUltimoContacto[0]['instancias'] !== undefined &&
      datosUltimoContacto.datosUltimoContacto[0]['instancias'] !== null &&
      datosUltimoContacto.datosUltimoContacto[0]['instancias'] !== ''
      ? datosUltimoContacto.datosUltimoContacto[0]['instancias']
      : ''
  )  
},[datosUltimoContacto])

 
 
 const obtenerColumnas = () => {
  return [
    
    
    {
      dataField: 'glosaHito',
      text:cfg_form24 && cfg_form24.cfg_form24[
        'consultactotercero-grilla-modocto'
      ],
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'fechaHitoFormat',
      text:cfg_form24 && cfg_form24.cfg_form24[
        'consultactotercero-grilla-fechaocurre'
      ],
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'comentario',
      text:cfg_form24 && cfg_form24.cfg_form24[
        'consultactotercero-grilla-comentario'
      ],
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' },
      formatter:(cell, row)=>{
        if(cell?.length>30) {
          return <>        
              <a href='#' style={{textDecoration:'none'}} onClick={(e)=>{
                 e.preventDefault()
                alert(cell)}}>{cell?.substring(0,30)}</a>
                
          </>
         }else{
             return cell
         }
       }
    },
    {
      dataField: 'usuario',
      text: cfg_form24 && cfg_form24.cfg_form24[
        'consultactotercero-grilla-usuario'
      ],
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
    {
      dataField: 'fechaRegistroHitoFormat',
      text:cfg_form24 && cfg_form24.cfg_form24[
        'consultactotercero-grilla-fechareg'
      ],
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
   
  ]
}
const handleShow=(row)=>{
  console.log(row.folioCarga)
}
  return (
    <>
      <style type='text/css'>
        {`
    .btn-carpeta {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    } 
    .btn-cambiar {
      background-color:  #286FBF;
      color: #FFFFFF;
      width: 140px;     
      padding:6px 0px 6px 0px;
    }
    .btn-cambiar:hover{
        background-color:  #5b9ad1;
        color: #FFFFFF;
    }
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    .btn-recepcionar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-recepcionar:hover{
        background-color: #F6897E;
      color: #FFFFFF;
    }
    .btn-volver {
      
      color: #66CCCC;
      border: 1px solid #C00
     
      width: 140px;

    }
   

    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    `}
      </style>
    
      <Container>
      <Row>
          <Col className='mx-3 mt-2'>
          <Form.Label
                        className='mb-0 mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      > Intancias</Form.Label>
                <br></br>
                <div style={{marginLeft:"20px"}}> 
                    {instancias && instancias}

                </div>
          </Col>
        <Col className='d-flex align-items-end justify-content-end m-2'>
          <Button className='m-2 w-auto' variant='outline-info' onClick={handleClose}   >
          {cfg_form24 && cfg_form24.cfg_form24["consultactotercero-btn-cerrar"]}
          </Button>
          
          
        </Col>
      </Row>
      <Row className='mt-4 mb-3'>
          <Col>
            <ToolkitProvider
                search
                bootstrap4
                keyField='secuencia'
                data={listaGrilla ? listaGrilla : []}
                columns={obtenerColumnas()}
                defaultSorted={[{ dataField: 'secuencia', order: 'asc' }]}
               
                >
                {(props) => (
                    <div>
                   

                    <BootstrapTable
                        {...props.baseProps}
                        bordered={false}
                        headerWrapperClasses='table-secondary'
                        pagination={paginationFactory({ sizePerPage: 5})}
                        noDataIndication={
                        <div className='text-center'>
                            No hay registros encontrados
                        </div>
                        }
                    />
                    </div>
                )}
            </ToolkitProvider>
          </Col>
      </Row>
      </Container>
    </>
  )
}

export default Historial
